import { PageInfo } from 'src/assets/types/interface/page-info.interface';
import { PageAbove } from 'src/assets/types/interface/page-info.interface';
import { firstValueFrom } from 'rxjs';
import { ServiceOrderService } from 'src/app/services/apps/service-order/service-order.service';
import {
  NavigationContext,
  navigationSourceLabel,
  splitManagementUrl,
} from 'src/app/services/navigation/navigation-context.service';

export async function buildServiceOrderPageInfo(
  uuid: string,
  tenantType: string,
  serviceOrderService: ServiceOrderService,
  navigationContext: NavigationContext = {
    source: 'service-orders',
    returnUrl: null,
  },
): Promise<PageInfo> {
  try {
    const request$ =
      tenantType === 'Prestador'
        ? serviceOrderService.findProviderServiceOrder(uuid)
        : serviceOrderService.findServiceOrder(uuid);

    const serviceOrder = await firstValueFrom(request$);

    if (!serviceOrder) {
      return fallbackPageInfo(navigationContext);
    }

    return {
      identification:
        serviceOrder.global_number ?? serviceOrder.local_number ?? '',
      title: 'Ordem de Serviço: ',
      pagesAbove: [originPage(serviceOrder, navigationContext)],
    };
  } catch (err) {
    console.error('Erro ao buscar detalhes da OS:', err);
    return fallbackPageInfo(navigationContext);
  }
}

function originPage(
  serviceOrder: {
    demand?: { uuid?: string; local_number?: string | null } | null;
  },
  context: NavigationContext,
): PageAbove {
  if (context.source === 'demand' && serviceOrder.demand?.uuid) {
    return pageFromReturnUrl(context, {
      title: 'Solicitação de Serviço: ',
      url: `/gestao/solicitacoes/detalhes/${serviceOrder.demand.uuid}`,
      identification: serviceOrder.demand.local_number ?? '',
      description: 'Solicitação relacionada à ordem de serviço',
    });
  }

  const defaults: Record<
    Exclude<NavigationContext['source'], 'demand'>,
    PageAbove
  > = {
    'service-orders': {
      title: 'Ordens de Serviço',
      url: '/gestao/ordens-servico',
      description: 'Listagem das ordens de serviço',
    },
    approvals: {
      title: 'Aprovações',
      url: '/gestao/aprovacoes',
      description: 'Fluxo de aprovações',
    },
    agenda: {
      title: 'Agenda de Serviços',
      url: '/gestao/agenda',
      description: 'Agenda de serviços',
    },
  };
  const source =
    context.source === 'demand' ? 'service-orders' : context.source;
  return pageFromReturnUrl(context, defaults[source]);
}

function pageFromReturnUrl(
  context: NavigationContext,
  fallback: PageAbove,
): PageAbove {
  const returnTarget = context.returnUrl
    ? splitManagementUrl(context.returnUrl)
    : null;
  if (!returnTarget) return fallback;

  return {
    ...fallback,
    title: navigationSourceLabel(context.source),
    url: returnTarget.path,
    queryParams: returnTarget.queryParams,
  };
}

function fallbackPageInfo(context: NavigationContext): PageInfo {
  return {
    identification: '',
    title: 'Ordem de Serviço: ',
    pagesAbove: [
      pageFromReturnUrl(context, {
        title: 'Ordens de Serviço',
        url: '/gestao/ordens-servico',
        description: 'Listagem das ordens de serviço',
      }),
    ],
  };
}
